import { Control } from 'react-hook-form';
import Input from 'components/Common/Input';
import Select from 'components/Common/Select';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { OutboundSipTrunkResponse } from 'apis/business/agent/deployPhone/outBoundSipTrunk/types';

type OutboundSipTrunkAdditionalConfigProps = {
  control: Control<OutboundSipTrunkResponse>;
  showOptionalAuthUsername?: boolean;
  borderTop?: boolean;
  showWhitelistedIp?: boolean;
};

export default function OutboundSipTrunkAdditionalConfig({
  control,
  showOptionalAuthUsername = false,
  borderTop = false,
  showWhitelistedIp = false
}: OutboundSipTrunkAdditionalConfigProps) {
  return (
    <>
      <Grid size={12}>
        <Typography
          fontWeight={500}
          fontSize={borderTop ? undefined : 16}
          marginTop={2}
          paddingTop={2}
          {...(borderTop && { borderTop: '1px solid rgb(207, 201, 201)' })}
        >
          Additional Configuration
        </Typography>
      </Grid>

      <Grid size={12} mt={1}>
        <Select
          label='Media Encryption'
          name='additional_config.media_encryption'
          sx={{ bgcolor: 'white' }}
          control={control}
          options={[
            { label: 'Disable Encryption', value: 0 },
            { label: 'Allow Encryption', value: 1 },
            { label: 'Require Encryption', value: 2 }
          ]}
        />
      </Grid>

      <Grid size={12} mt={1}>
        <Select
          label='Transport'
          sx={{ bgcolor: 'white' }}
          name='additional_config.transport'
          control={control}
          options={[
            { label: 'Auto', value: 0 },
            { label: 'UDP', value: 1 },
            { label: 'TCP', value: 2 },
            { label: 'TLS', value: 3 }
          ]}
        />
        <Typography color='text.secondary' lineHeight={1.5} fontSize={12} mt={0.5}>
          When set to Auto, the transport protocol will be identified automatically
        </Typography>
      </Grid>

      <Grid size={12} mt={1}>
        <Input
          control={control}
          fullWidth
          label='Outbound Proxy'
          placeholder='sip:example.com:5060'
          name='additional_config.outbound_proxy'
          sx={{ backgroundColor: 'white' }}
        />
      </Grid>

      {showWhitelistedIp && (
        <Grid size={12} mt={1}>
          <Input
            control={control}
            fullWidth
            label='Whitelisted IP'
            placeholder='e.g. 203.0.113.10'
            name='additional_config.whitelisted_ip'
            sx={{ backgroundColor: 'white' }}
          />
          <Typography color='text.secondary' lineHeight={1.5} fontSize={12} mt={0.5}>
            We will use this IP to whitelist. If not provided, we will use the proxy to resolve the IP.
          </Typography>
        </Grid>
      )}

      {showOptionalAuthUsername && (
        <Grid size={12} mt={1}>
          <Input
            control={control}
            fullWidth
            label='Auth Username'
            placeholder='Enter auth name'
            name='additional_config.auth_username'
            sx={{ backgroundColor: 'white' }}
          />
        </Grid>
      )}
    </>
  );
}
